import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { CANCELLED_STYLES } from "constants/action-types";
import {
    fetchActions,
    IFetchStoreState,
    initialBaseState,
    initialFetchState,
    updateActions,
    updateStateActions,
} from "./base-reducers";
import { ICancelledStyle } from "constants/cancelled-styles-types";
import { IV3Order as IOrder } from "constants/order-types";

export interface ICancelledStylesState {
    orders: IOrdersState;
    styles: IStylesState;
    order_styles: IOrderStylesState;
    order: IFetchStoreState<IOrder>;
    style: IStyleState;
    drop: IDropState;
}

export interface IDropPayload {
    success: boolean;
    next: string;
    errors: string[];
}

export interface IOrderStylesPayload {
    order: IOrder;
    styles: ICancelledStyle[];
}

interface IOrdersState {
    count: number;
}

interface IStylesState extends IFetchStoreState<ICancelledStyle[]> {
    count: number;
}

type IStyleState = IFetchStoreState<ICancelledStyle>;
type IDropState = IFetchStoreState<IDropPayload>;
type IOrderStylesState = IFetchStoreState<IOrderStylesPayload>;

export const cancelledStyles = combineReducers<ICancelledStylesState>({
    orders: handleActions<IOrdersState>(
        {
            ...updateStateActions<IOrdersState>(CANCELLED_STYLES.ORDERS),
        } as any,
        {
            count: null,
        }
    ),
    styles: handleActions<IStylesState>(
        {
            ...fetchActions<ICancelledStyle[]>(CANCELLED_STYLES.STYLES.FETCH),
            ...updateStateActions<IStylesState>(CANCELLED_STYLES.STYLES),
        } as any,
        {
            ...initialFetchState,
            count: null,
        }
    ),
    order_styles: handleActions<IOrderStylesState, IOrderStylesPayload>(
        {
            ...fetchActions(CANCELLED_STYLES.ORDER_STYLES.FETCH),
            ...updateActions(CANCELLED_STYLES.ORDER_STYLES),
        } as any,
        {
            ...initialBaseState,
            payload: undefined, // undefined state for correct start fetching
        }
    ),
    order: handleActions<IFetchStoreState<IOrder>>(
        {
            ...fetchActions(CANCELLED_STYLES.ORDER.FETCH),
            ...updateActions(CANCELLED_STYLES.ORDER),
        } as any,
        initialBaseState
    ),
    style: handleActions<IStyleState>(
        {
            ...fetchActions(CANCELLED_STYLES.STYLE.FETCH),
            ...updateActions(CANCELLED_STYLES.STYLE),
        } as any,
        {
            ...initialBaseState,
            payload: undefined, // undefined state for correct start fetching
        }
    ),
    drop: handleActions<IDropState>(
        {
            ...fetchActions<IDropPayload>(CANCELLED_STYLES.DROP),
        } as any,
        initialFetchState
    ),
});
